export default __webpack_public_path__ + "static/media/obj1.4707f1af.jpg";